module.exports = __webpack_public_path__ + "img/logo-y.7c946251.png";